// extracted by mini-css-extract-plugin
export default {"definingsection":"a80a0e394d07d700337f","codeview":"a3f3f4b108bc2c5203a6"};